import {http} from "@/plugins/axios"

//export default function() {

    function findAll () {
        return http
            .get("/sancoes")
            .then((response) => response.data)
            .catch((e) => {
                console.log(e);
            });
    }

    function buscar (id) {

        return http
            .get(`sancoes/${id}`)
            .then(res => res.data)
            .catch((e) => {
                console.log(e);
            });
    }

    function buscarSancaoFiltro (filtro) {

        return http
            .get("sancoes/filtro", {
                params: {
                    numeroProcesso: filtro.numeroProcesso,
                    orgao: filtro.orgao,
                    cpfCnpj: filtro.cpfCnpj,
                    sancionado: filtro.sancionado,
                    inicioSancao: filtro.inicioSancao,
                    fimSancao: filtro.fimSancao
                }
            })
            .then(res => res.data || [])
            .catch((e) => {
                console.error(e);
                throw e; // a tela decide o que mostrar (aviso de indisponibilidade)
            });
    }

    function salvar(sancao) {
        if (sancao.sancaoId == null) {
            
            return http
                .post("sancoes/", sancao)
                .then((response) => response.data)
                .catch(err => console.error(err.message));
        } else {
            return http
                .put(`sancoes/${sancao.sancaoId}`, sancao)
                .then(response => response.data)
                .catch(err => console.error(err.message));
        }
    
    }
    
    function excluir(id){
        return http
            .delete(`/sancoes/${id}`)
            .then(res => {
                if(res.status === 204){
                    alert("Registro excluído com sucesso.")
                    return "ok"
                }
            })
            .catch((e) => {
                console.log(e);
                alert("Erro na solicitação.")
                return "erro"
            });
    }

    let service = {}
    service.findAll = findAll
    service.buscar = buscar
    service.buscarSancaoFiltro = buscarSancaoFiltro
    service.salvar = salvar
    service.excluir = excluir

    export default service

//}

